package pwgs.ui.scenes.analyticsdashboardscene

import kotlinx.browser.window
import pwgs.ui.components.BarChart
import pwgs.ui.components.BarChartItem
import pwgs.ui.components.BigStatNumber
import visage.core.AComponent
import visage.core.Components
import visage.core.AScene
import visage.dom.tag
import visage.ds.colorpalette.Skin
import visage.ds.components.Card
import visage.ds.components.ETextStyles
import visage.ds.components.Text
import visage.ds.components.page.Page

class MAnalyticsDashboardScene(props: AnalyticsDashboardSceneProps) : AScene<AnalyticsDashboardSceneProps, AnalyticsDashboardSceneModel, AnalyticsDashboardSceneState, AnalyticsDashboardControllerFe>(props) {

    override fun createController() : AnalyticsDashboardControllerFe {
        return AnalyticsDashboardControllerFe(props, this)
    }

    override fun initState() : AnalyticsDashboardSceneState {
        return AnalyticsDashboardSceneState(null)
    }

    override fun onComponentDidMount() {
        super.onComponentDidMount()
        var timerId = window.setInterval({
            this@MAnalyticsDashboardScene.controller.refreshRealtimeStats()
        }, 3000)
        this.state = AnalyticsDashboardSceneState(timerId)

    }

    override fun onComponentDidUnmount() {
        super.onComponentDidUnmount()
        if (this.state.timerId != null) {
            window.clearInterval(this.state.timerId!!)
        }
    }

    override fun Components.render(children: List<AComponent<*>>) {
        val model = this@MAnalyticsDashboardScene.model
        val controller = this@MAnalyticsDashboardScene.controller

        var last30NewUsersCount = 0L
        var last30ReturningUsersCount = 0L
        var last30TotalUsersCount = 0L
        var last30SessionsCount = 0L

        model.last30DayStats.forEach {
            last30NewUsersCount += it.newUsersCount
            last30ReturningUsersCount += it.returningUsersCount
            last30TotalUsersCount += it.newUsersCount + it.returningUsersCount
            last30SessionsCount += it.sessionsCount
        }

        Page {
            head("Analytics > Dashboard")

            body {
                Card {
                    header("Today")

                    body {
                        tag("div") {
                            style.apply {
                                display = "flex"
                                flexWrap = "wrap"
                                alignItems = "flex-end"
                                justifyContent = "center"
                                width = "100%"
                            }

                            tag("div") {
                                style.apply {
                                    display = "inline-block"
                                    width = "200px"
                                }

                                BigStatNumber("Current players", model.realtimeStats.onlineUsersCount.toString(), Skin.palette.normalTextColor)
                            }

                            tag("div") {
                                style.apply {
                                    display = "inline-block"
                                    width = "200px"
                                }

                                BigStatNumber("New players today", model.realtimeStats.newUsersCount.toString(), Skin.palette.successColor)
                            }

                            tag("div") {
                                style.apply {
                                    display = "inline-block"
                                    width = "200px"
                                }

                                BigStatNumber("Returning players today", model.realtimeStats.returningUsersCount.toString(), Skin.palette.infoColor)
                            }

                            tag("div") {
                                style.apply {
                                    display = "inline-block"
                                    width = "200px"
                                }

                                BigStatNumber("Total players today", (model.realtimeStats.newUsersCount + model.realtimeStats.returningUsersCount).toString(), Skin.palette.warningColor)
                            }

                            tag("div") {
                                style.apply {
                                    display = "inline-block"
                                    width = "200px"
                                }

                                BigStatNumber("Sessions today", model.realtimeStats.sessionsCount.toString(), Skin.palette.dangerColor)
                            }
                        }
                    }
                }

                var maxValue = 0L
                model.last30DayStats.forEach {
                    if (it.sessionsCount > maxValue) {
                        maxValue = it.sessionsCount
                    }
                }

                Card {
                    header("New players last 30 days: $last30NewUsersCount")

                    body {
                        BarChart(200, Skin.palette.successColor, maxValue.toInt(), model.last30DayStats.map {
                            BarChartItem("${it.date}: ${it.newUsersCount}", it.newUsersCount.toInt())
                        })
                    }
                }

                Card {
                    header("Returning players last 30 days: $last30ReturningUsersCount")

                    body {
                        BarChart(200, Skin.palette.infoColor, maxValue.toInt(), model.last30DayStats.map {
                            BarChartItem("${it.date}: ${it.returningUsersCount}", it.returningUsersCount.toInt())
                        })
                    }
                }

                Card {
                    header("Total players last 30 days: ${last30NewUsersCount + last30ReturningUsersCount}")

                    body {
                        BarChart(200, Skin.palette.warningColor, maxValue.toInt(), model.last30DayStats.map {
                            BarChartItem("${it.date}: ${it.returningUsersCount + it.newUsersCount}", (it.returningUsersCount + it.newUsersCount).toInt())
                        })
                    }
                }

                Card {
                    header("Sessions last 30 days: $last30SessionsCount")

                    body {
                        BarChart(200, Skin.palette.dangerColor, maxValue.toInt(), model.last30DayStats.map {
                            BarChartItem("${it.date}: ${it.sessionsCount}", (it.sessionsCount).toInt())
                        })
                    }
                }
            }
        }
    }
}

class AnalyticsDashboardSceneState(val timerId: Int?) {

}

fun Components.AnalyticsDashboardScene(props: AnalyticsDashboardSceneProps) = this.registerComponent(MAnalyticsDashboardScene(props), {})
